import React, { FunctionComponent } from 'react'
import BodyFont from '../../../Theme/Fonts/Body'

export type CaptionProps = { caption: string }

const Caption: FunctionComponent<CaptionProps> = ({ caption }) => (
    <BodyFont bold color="WHITE" textAlign="center">
        {caption}
    </BodyFont>
)
export default Caption
